import React from "react";
import PropTypes from "prop-types";
import RichTextEditor from "react-rte";
import './editor-style.css'

class MarkdownEditor extends React.Component {
  constructor(props) {
    super(props);
    let value = null;
    if (props.value) {
      value = RichTextEditor.createValueFromString(props.value, 'markdown');
    } else {
      value = RichTextEditor.createEmptyValue();
    }
    this.state = {
      value: value
    };
  }

  onChange = (value) => {
    this.setState({value});
    if (this.props.onChange) {
      // Send the changes up to the parent component as an HTML string.
      // This is here to demonstrate using `.toString()` but in a real app it
      // would be better to avoid generating a string on each change.
      this.props.onChange(
        value.toString("markdown")
      );
    }
  };

  render () {
  const toolbarConfig = {
    display: [
      "INLINE_STYLE_BUTTONS", "BLOCK_TYPE_BUTTONS",
      "LINK_BUTTONS", "BLOCK_TYPE_DROPDOWN", /*"HISTORY_BUTTONS"*/
    ],
    INLINE_STYLE_BUTTONS: [
      {label: "Bold", style: "BOLD"},
      {label: "Italic", style: "ITALIC"},
      /* Underline causes problems with our MarkdownReader
      {label: "Underline", style: "UNDERLINE"}*/
    ],
    BLOCK_TYPE_DROPDOWN: [
      {label: "Normal", style: "unstyled"},
      //{label: "Heading Large", style: "header-one"},
      // {label: "Header", style: "header-two"},
      {label: "Title", style: "header-three"}
    ],
    BLOCK_TYPE_BUTTONS: [
      {label: "UL", style: "unordered-list-item"},
      {label: "OL", style: "ordered-list-item"},
      {label: "Blockquote", style: "blockquote"},
    ]
  };
    return (
      <RichTextEditor
        value={this.state.value}
        onChange={this.onChange}
        toolbarConfig={toolbarConfig}
        toolbarClassName="custom-toolbar"
        editorClassName="custom-editor"
      />
    );
  }
}

MarkdownEditor.propTypes = {
  onChange: PropTypes.func
};

export default MarkdownEditor;




// WEBPACK FOOTER //
// ./src/components/interactive/markdown/MarkdownEditor.js